import React, { createContext, useState } from 'react'

import { loadByCidFilter } from '../../providers/actions/loadByCid'

type LoadSearchEngineParams = {
  policyId: string;
  categorization?: Array<string>;
  dateStart?: string | null;
  dateEnd?: string | null;
  departments?: Array<string>;
  inputTemplate?: string;
  pageStart?: number;
  pageRows?: number;
  tag?: string;
  searchTag?: string;
  searchText?: string;
}

type LoadSearchEngineOptions = {
  isSearchEngine?: boolean;
  isPaginated?: boolean;
}

type FilterDataContextProps = {
  collections: {
    [key: string]: { data: Array<any>; totalItems: number; }
  }
  items: any
  loading: boolean
  totalItems: any

  loadSearchEngineData: (P: LoadSearchEngineParams, O: LoadSearchEngineOptions) => void
}

type FilterDataProviderStateType = {
  [key: string]: { data: Array<any>; totalItems: number; }
}
export interface FilterDataProviderProps {
  children: any
}

export const FilterDataContext = createContext<FilterDataContextProps>({
  collections: {},
  items: [],
  loading: false,
  totalItems: 0,
  loadSearchEngineData: () => null,
})

const FilterDataProvider: React.FC<FilterDataProviderProps> = ({ children }) => {
  const [state, setState] = useState<FilterDataProviderStateType>({})
  const [loading, setLoading] = useState<boolean>(false)
  const [totalItems, setTotalItems] = useState<number>(0)

  const handleSearchEngineState = (policyId, payload) => {
    setState((prevState) => {
      setLoading(false)
      const totalItems = payload.success ? payload.totalItems : 0
      return { ...prevState, [policyId]: { data: [...payload.pageData], totalItems } }
    })
  }

  const handlePaginatedState = (policyId, payload) => {
    setState((prevState) => {
      setLoading(false)
      const selectedPrevState = prevState[policyId] ? prevState[policyId].data : []
      const totalItems = payload.success ? payload.totalItems : 0
      return { ...prevState, [policyId]: { data: [...selectedPrevState, ...payload.pageData], totalItems } }
    })
  }

  const loadSearchEngineData = (data: LoadSearchEngineParams, options: LoadSearchEngineOptions) => {
    setLoading(true)
    const policyId = data.policyId

    const parsedFilters = {
      policyId
    }

    if (data.categorization?.length !== 0) {
      parsedFilters['categorization'] = data.categorization
    }
    if (data.dateStart) {
      parsedFilters['dateStart'] = data.dateStart
    }
    if (data.dateEnd) {
      parsedFilters['dateEnd'] = data.dateEnd
    }
    if (data.departments?.length !== 0) {
      parsedFilters['departments'] = data.departments?.map((i) => i.replace('policy:', '')).join(' OR ')
    }
    if (data.inputTemplate !== '') {
      parsedFilters['inputTemplate'] = data.inputTemplate
    }
    if (typeof data.pageRows === 'number') {
      parsedFilters['pageRows'] = data.pageRows
    }
    if (typeof data.pageStart === 'number') {
      parsedFilters['pageStart'] = data.pageStart
    }
    if (data.searchTag !== '') {
      parsedFilters['searchTag'] = data.searchTag
    }
    if (data.searchText !== '') {
      parsedFilters['searchText'] = data.searchText
    }

    const setterFunction = (payload) => {
      if (payload.success === true) {
        if (options.isPaginated) {
          handlePaginatedState(policyId, payload)
        }
        if (options.isSearchEngine) {
          handleSearchEngineState(policyId, payload)
        }
      }
    }
    loadByCidFilter(parsedFilters, setterFunction)
  }

  return (
    <FilterDataContext.Provider
      value={{
        items: [],
        loading,
        totalItems,
        collections: state,
        loadSearchEngineData
      }}
    >
      {children}
    </FilterDataContext.Provider>
  )
}

export default FilterDataProvider
